
import { Label } from "@/components/ui/label";

interface CustomNameInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function CustomNameInput({ value, onChange }: CustomNameInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value.trim();
    if (newValue === '.') {
      return;
    }
    onChange(newValue);
  };

  return (
    <div className="w-full mt-4">
      <Label htmlFor="customName" className="text-sm font-medium text-white">
        Nombre para el envío
      </Label>
      <input
        id="customName"
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Ingrese un nombre para el envío"
        className="flex h-10 w-full rounded-md border border-white/10 bg-white/5 px-3 py-2 text-sm text-white ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-white/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
      />
    </div>
  );
}
